var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classe + ' box-show'},[_c('div',{staticClass:"graficos"},[_c('line-chart',{staticClass:"wrapper",attrs:{"chartData":_vm.chartData}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }